import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { useState } from "react";

export default function Contacto() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({ name: false, email: false, message: false });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {
      name: form.name.trim() === "",
      email: !validateEmail(form.email),
      message: form.message.trim() === ""
    };

    setErrors(newErrors);
    if (Object.values(newErrors).some(Boolean)) return;

    const formEndpoint = "https://formspree.io/f/mgvylvgk"; 
    fetch(formEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    })
      .then(() => {
        alert("Mensaje enviado correctamente");
        setForm({ name: "", email: "", message: "" });
      })
      .catch(() => {
        alert("Hubo un error al enviar tu mensaje");
      });
  };


  return (
    <Section id="contacto">
      <FinalCall>
        <Heading>{t("contacto.titulo")}</Heading>
        <Text>{t("contacto.descripcion")}</Text>
        <ButtonsWrapper>
          <Button
            href="https://wa.me/522441043578?text=Hola,%20me%20gustaría%20una%20cotización"
            target="_blank"
            rel="noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaWhatsapp /> WhatsApp
          </Button>
          <Button
            href="mailto:reddigitalcreations.y@gmail.com"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaEnvelope /> {t("contacto.correo")}
          </Button>
        </ButtonsWrapper>
      </FinalCall>
     <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="name"
          placeholder="Tu nombre"
          value={form.name}
          onChange={handleChange}
          hasError={errors.name}
          required
        />
        <Input
          type="email"
          name="email"
          placeholder="Tu correo"
          value={form.email}
          onChange={handleChange}
          hasError={errors.email}
          required
        />
        <Textarea
          name="message"
          placeholder="¿En qué puedo ayudarte?"
          value={form.message}
          onChange={handleChange}
          hasError={errors.message}
          required
        />
        <MotionSubmitButton
          type="submit"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Enviar mensaje
        </MotionSubmitButton>
      </Form>


    </Section>
  );
}
const Section = styled.section`
  padding: 2rem 1.5rem;
  text-align: center;
  background-color: #0D0D0D;
`;

const Heading = styled.h2`
  font-size: 2rem;
  color: #FF4C4C;
  margin-bottom: 0.5rem;
`;

const Text = styled.p`
  color: #CCCCCC;
  margin-bottom: 2rem;
`;

const FinalCall = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  @media(min-width: 600px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const Button = styled(motion.a)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #FF4C4C;
  color: white;
  padding: 0.75rem 1.25rem;
  border-radius: 0.75rem;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s;
  min-width: 9rem;
  display: flex;
  justify-content: center;
`;



const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 600px;
  margin: 2rem auto 0;
`;

const Input = styled.input`
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: none;
  background-color: #1E1E1E;
  color: white;
  font-size: 1rem;
  outline: none;
  border: ${(props) => (props.hasError ? '2px solid #FF4C4C' : 'none')};

  &::placeholder {
    color: #888;
  }
`;

const Textarea = styled.textarea`
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: none;
  background-color: #1E1E1E;
  color: white;
  font-size: 1rem;
  resize: none;
  min-height: 120px;
  outline: none;
  border: ${(props) => (props.hasError ? '2px solid #FF4C4C' : 'none')};

  &::placeholder {
    color: #888;
  }
`;

const MotionSubmitButton = styled(motion.button)`
  background-color: #FF4C4C;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background-color: #ff1a1a;
  }
`;